import ManualAccessControlIcon from '@material-ui/icons/ViewList';

import ManualAccessControlList from './ManualAccessControlList';

export default {
  list: ManualAccessControlList,
  icon: ManualAccessControlIcon,
};
